import { child, ref, get, set, update } from 'firebase/database'
import type { FirebaseUser, FirebaseUserActions, Preferences } from '~/types/UserData'
import { zUser } from '~/types/UserData'

// NOTE: This entire file is legacy implementation quickly hacked to work with vue-fire
// instead of directly initializing multiple conflicting firebase instances

function firebaseInit() {
  const db = useDatabase()
  const dbRef = ref(db)
  const userDB = useRuntimeConfig().public.FB_USER_DB
  return {
    getOneUsersData: async (uid: string): Promise<FirebaseUser> => {
      let data = {}
      await get(child(dbRef, `${userDB}/${uid}`))
        .then(snapshot => {
          if (snapshot.exists()) {
            data = zUser.parse(snapshot.val())
          } else {
            data = zUser.parse({})
          }
        })
        .catch(error => {
          throw new Error(error)
        })
      return zUser.parse(data)
    },

    updateUserPreferences: async (uid: string, preferences: Preferences): Promise<void> => {
      try {
        await set(ref(db, `${userDB}/${uid}/preferences`), preferences)
      } catch (error) {
        console.log(error)
      }
    },

    updateUserActions: async (uid: string, actions: FirebaseUserActions): Promise<void> => {
      try {
        await set(ref(db, `${userDB}/${uid}/actions`), actions)
      } catch (error) {
        console.log(error)
      }
    },
    updateUserHints: async (uid: string, hints: Preferences): Promise<void> => {
      try {
        await set(ref(db, `${userDB}/${uid}/hints`), hints)
      } catch (error) {
        console.log(error)
      }
    },
    initUserDocument: async (uid: string, data: any): Promise<void> => {
      try {
        await set(ref(db, `${userDB}/${uid}`), data)
      } catch (error) {
        console.log(error)
      }
    },
    updateUserDocument: async (uid: string, data: any): Promise<void> => {
      try {
        await update(ref(db, `${userDB}/${uid}`), data)
      } catch (error) {
        console.log(error)
      }
    },
  }
}

export { firebaseInit }
